import { render, staticRenderFns } from "./My_Tx_Record.vue?vue&type=template&id=8f8b3bf2&scoped=true"
import script from "./My_Tx_Record.vue?vue&type=script&lang=js"
export * from "./My_Tx_Record.vue?vue&type=script&lang=js"
import style0 from "./My_Tx_Record.vue?vue&type=style&index=0&id=8f8b3bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b3bf2",
  null
  
)

export default component.exports